import UserApi from '@/api/Users/api'
import ClientApi from '@/api/Clients/api'

export default {
  methods: {
    async getWithSearch (search, type) {
      if (!search) return []
      const getRequest = type === 'user' ? UserApi.getUsersList : ClientApi.getClientsList
      try {
        const resp = await getRequest({limit: 100, page: 1, search: search})
        const prop = type === 'user' ? 'users' : 'clients'
        return resp.data[prop]
      } catch (e) {
        console.error(e)
        return []
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getWithElasticsearch.js